/* "Arma tu rutina" en filas limpias (16-sep-2026). Markup y datos: snippets/hai-fbt.liquid.

   Principios (heredados del combo de julio):
   - El DOM es la única fuente de verdad: cada pintado relee las filas. Nada de NodeLists
     cacheadas que un re-render deje describiendo nodos muertos.
   - Cada fila declara sus complementarios (data-comp-ids, data-comp-total); el producto
     fijo vive en la raíz (data-fijo-id, data-fijo-precio) y cambia con la escalera/picker
     del tema (variant:change). Este script no sabe de productos ni de precios: suma.
   - Listeners delegados en document: sobreviven a que el editor reemplace la sección.
   - Fuera del DOM vive solo lo que el DOM no sabe: el carrito (API: el total y qué variantes trae).
   - El alta la hace hai-quick-add.js ([data-hai-agregar]); aquí solo se pinta la respuesta
     (verde "En tu carrito") y se relee el carrito para la barra. */

(function () {
  'use strict';

  if (window.__haiFbt) return;
  window.__haiFbt = true;

  var money = function (n) { return '$' + Math.round(n).toLocaleString('es-CL'); };

  /* El carrito: el total en pesos y qué variantes trae. La barra responde a «con esta rutina, ¿dónde queda tu
     pedido?»: si la rutina elegida ya está entera en el carrito (recién agregada, o de antes), es el carrito tal cual;
     si no, el carrito más la rutina. Hasta el 25-oct-2026 sumaba siempre la rutina y, recién agregada, la contaba dos
     veces: decía «Envío gratis incluido» mientras el aviso y la línea de envío decían «Te faltan…». */
  var carrito = 0;
  var enCarrito = {};

  function tomarCarrito(cart) {
    carrito = Math.round((cart.total_price || 0) / 100);
    enCarrito = {};
    (cart.items || []).forEach(function (it) {
      var id = String(it.variant_id || it.id);
      enCarrito[id] = (enCarrito[id] || 0) + (it.quantity || 0);
    });
  }

  function leerCarrito() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(tomarCarrito)
      .catch(function () {});
  }

  function raices() { return Array.prototype.slice.call(document.querySelectorAll('[data-hai-fbt]')); }
  function filas(root) { return Array.prototype.slice.call(root.querySelectorAll('[data-fila]')); }
  function fijo(root) {
    return { id: parseInt(root.dataset.fijoId, 10), precio: parseInt(root.dataset.fijoPrecio, 10) || 0 };
  }
  function totalDe(root, fila) { return fijo(root).precio + (parseInt(fila.dataset.compTotal, 10) || 0); }
  function idsDe(root, fila) {
    var comp = (fila.dataset.compIds || '').split(',').filter(Boolean);
    return [String(fijo(root).id)].concat(comp).join(',');
  }
  function elegida(root) {
    return root.querySelector('[data-fila][aria-checked="true"]') || filas(root)[0];
  }
  function pedidoCon(root, fila) {
    var yaEsta = idsDe(root, fila).split(',').every(function (id) { return (enCarrito[id] || 0) > 0; });
    return yaEsta ? carrito : carrito + totalDe(root, fila);
  }

  function pintar(root) {
    var umbral = parseInt(root.dataset.umbral, 10) || 0;
    var lista = filas(root);
    var sel = elegida(root);
    if (!sel) return;

    lista.forEach(function (fila) {
      var t = totalDe(root, fila);
      var precio = fila.querySelector('[data-precio]');
      if (precio) precio.textContent = money(t);
      var tag = fila.querySelector('[data-tag]');
      var conEnvio = umbral > 0 && pedidoCon(root, fila) >= umbral;
      if (tag) tag.hidden = !conEnvio;
      var det = fila.querySelector('[data-det]');
      var pauta = fila.querySelector('[data-pauta]');
      if (det) det.hidden = !((pauta && pauta.textContent.trim()) || conEnvio);
    });

    var n = parseInt(sel.dataset.n, 10) || 1;
    root.querySelectorAll('.hai-fbt__tira img').forEach(function (img) {
      img.dataset.off = (parseInt(img.dataset.k, 10) || 1) > n ? '1' : '0';
    });

    var boton = root.querySelector('[data-hai-agregar]');
    if (boton) {
      var ids = idsDe(root, sel);
      boton.dataset.haiAgregar = ids;
      /* Título del aviso al agregar (hai-quick-add.js lo lee al tocar): con un producto, su nombre; con la rutina,
         cuántos productos lleva, como «Quiero probarlas» («Hai Fórmulas (4 productos)»). */
      if (boton.dataset.haiNombre === undefined) boton.dataset.haiNombre = boton.dataset.haiTitulo || '';
      var cuantos = ids.split(',').length;
      boton.dataset.haiTitulo = cuantos > 1 ? 'Tu rutina (' + cuantos + ' productos)' : boton.dataset.haiNombre;
    }

    var barra = root.querySelector('[data-barra]');
    if (!barra || !umbral) return;
    var total = pedidoCon(root, sel);
    var falta = umbral - total;
    barra.hidden = false;
    var avance = root.querySelector('[data-avance]');
    if (avance) avance.style.width = Math.min(100, (total / umbral) * 100) + '%';
    barra.classList.toggle('is-listo', falta <= 0);
    var texto = root.querySelector('[data-texto]');
    if (texto) {
      texto.innerHTML = falta <= 0
        ? '<span class="hai-fbt__ok">✓</span> Envío gratis incluido'
        : 'Faltan <b>' + money(falta) + '</b> para envío gratis';
    }

    /* Un hito por cada pack que no alcanza la meta (el que la alcanza ES la meta). */
    var pista = root.querySelector('.hai-fbt__pista');
    if (!pista) return;
    Array.prototype.forEach.call(pista.querySelectorAll('.hai-fbt__paso'), function (p) { p.remove(); });
    var puestos = {};
    lista.forEach(function (fila) {
      var t = pedidoCon(root, fila);
      if (t >= umbral || puestos[t]) return;
      puestos[t] = true;
      var p = document.createElement('span');
      p.className = 'hai-fbt__paso' + (total >= t ? ' is-on' : '');
      p.style.left = ((t / umbral) * 100) + '%';
      pista.appendChild(p);
    });
  }

  function pintarTodos() { raices().forEach(pintar); }

  document.addEventListener('click', function (e) {
    var fila = e.target.closest && e.target.closest('[data-fila]');
    if (fila) {
      var root = fila.closest('[data-hai-fbt]');
      if (!root) return;
      root.dataset.haiTocada = '1';
      filas(root).forEach(function (f) { f.setAttribute('aria-checked', 'false'); });
      fila.setAttribute('aria-checked', 'true');
      pintar(root);
      return;
    }
    var boton = e.target.closest && e.target.closest('[data-hai-fbt] [data-hai-agregar]');
    if (boton) {
      /* hai-quick-add.js hace el alta (listener en captura); aquí solo se recuerda quién la pidió. */
      boton.closest('[data-hai-fbt]').dataset.pendiente = '1';
      boton.closest('[data-hai-fbt]').dataset.haiTocada = '1';
    }
  });

  document.addEventListener('ajaxProduct:added', function () {
    raices().forEach(function (root) {
      if (!root.dataset.pendiente) return;
      delete root.dataset.pendiente;
      var boton = root.querySelector('[data-hai-agregar]');
      if (!boton) return;
      var etq = boton.querySelector('[data-etiqueta]');
      var antes = etq ? etq.textContent : '';
      boton.classList.add('is-ok');
      if (etq) etq.textContent = '✓ En tu carrito';
      setTimeout(function () {
        boton.classList.remove('is-ok');
        if (etq) etq.textContent = antes;
      }, 1600);
      leerCarrito().then(function () { pintar(root); });
    });
  });

  document.addEventListener('ajaxProduct:error', function () {
    raices().forEach(function (root) { delete root.dataset.pendiente; });
  });

  /* La fila fija sigue a la variante elegida arriba (escalera o picker): "Combo: 3 X" suma
     y agrega ese combo. Se valida contra el mapa que la propia raíz declara, así un evento
     de OTRO producto no la pisa. */
  document.addEventListener('variant:change', function (e) {
    var variante = e.detail && e.detail.variant;
    if (!variante) return;
    raices().forEach(function (root) {
      var datos = root.querySelector('[data-fbt-variantes]');
      if (!datos) return;
      var mapa;
      try { mapa = JSON.parse(datos.textContent); } catch (err) { return; }
      var v = null;
      for (var i = 0; i < mapa.length; i++) {
        if (mapa[i].id === variante.id) { v = mapa[i]; break; }
      }
      if (!v) return;
      root.dataset.fijoId = v.id;
      root.dataset.fijoPrecio = v.precio;
      var nombre = root.querySelector('[data-fijo-nombre]');
      if (nombre && v.titulo) nombre.textContent = v.titulo;
      pintar(root);
    });
  });

  /* Cambios del carrito desde el drawer (cart.js del tema emite cart:updated con la
     respuesta completa como texto JSON) y vuelta desde el bfcache. */
  document.addEventListener('cart:updated', function (e) {
    try {
      var c = e.detail && e.detail.cart;
      if (typeof c === 'string') c = JSON.parse(c);
      if (c && typeof c.total_price === 'number') { tomarCarrito(c); pintarTodos(); }
    } catch (err) {}
  });
  /* Y cada vez que hai-quick-add.js relee el carrito (altas desde la ficha, las tarjetas o la rutina): sin esto, tras
     «Añadir al carrito» la barra seguía con el carrito de antes. */
  document.addEventListener('hai:carrito', function (e) {
    var c = e.detail && e.detail.cart;
    if (c && typeof c.total_price === 'number') { tomarCarrito(c); pintarTodos(); }
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) leerCarrito().then(pintarTodos); });

  /* Destello (25-oct-2026, tema B; Andrés: «mejor ese destello para la parte de arma tu rutina, esa era en realidad
     la parte que siento le falta»; ver hai-fbt.css). Cuando las filas quedan a la vista, una luz recorre el borde de
     la fila elegida (el dúo) --hai-destello-veces veces, una cada --hai-destello-cada segundos. Una vez por visita a
     la ficha; nunca si la persona ya tocó el bloque, ni con «reducir movimiento». Los valores viven en hai-fbt.css,
     junto a cómo se ve. */
  var destello = { hecho: false, reloj: 0 };

  function latidos(root, espera) {
    var raiz = getComputedStyle(document.documentElement);
    var cada = Math.max(1, parseFloat(raiz.getPropertyValue('--hai-destello-cada')) || 2) * 1000;
    var veces = Math.max(1, parseInt(raiz.getPropertyValue('--hai-destello-veces'), 10) || 2);
    var hechas = 0;
    clearTimeout(destello.reloj);
    var latir = function () {
      if (!root.isConnected || root.dataset.haiTocada) return;
      var fila = elegida(root);
      if (!fila) return;
      fila.classList.add('hai-destello');
      hechas += 1;
      if (hechas < veces) destello.reloj = setTimeout(latir, cada);
    };
    destello.reloj = setTimeout(latir, espera);
  }

  function vigilar(root) {
    // Al terminar la animación se quita la clase: el siguiente destello vuelve a empezar desde cero.
    root.addEventListener('animationend', function (e) {
      if (e.target.classList && e.target.classList.contains('hai-destello')) e.target.classList.remove('hai-destello');
    });
    if (destello.hecho || !('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var vigia = new IntersectionObserver(function (entradas) {
      if (!entradas.some(function (e) { return e.isIntersecting; })) return;
      vigia.disconnect();
      if (destello.hecho) return;
      destello.hecho = true;
      latidos(root, 800);
    }, { threshold: 0.6 });
    vigia.observe(root.querySelector('.hai-fbt__filas') || root);
  }

  function iniciar() {
    pintarTodos();
    leerCarrito().then(pintarTodos);
    raices().forEach(vigilar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }

  document.addEventListener('shopify:section:load', pintarTodos);
})();
